import { FrequencyConfig, IntervalTypes } from 'common/types/frequencySelector/frequencySelector';
import filter from 'lodash/filter';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { ScheduleSendValues } from './types/scheduleSend';

/**
 * Checks if the scheduled report is valid.
 * Returns `true` when all required fields are filled out.
 *
 * @returns {boolean}
 */
export const isValidScheduledReport = (scheduleSendValues: ScheduleSendValues): boolean => {
  const { frequencyConfig } = scheduleSendValues;
  const { hasEndDate } = frequencyConfig.datesInfo;
  const { type } = frequencyConfig.intervalInfo;
  const withEndDateArray = hasEndDate ? ['endDate'] : [];
  const requireDateFields = ['startDate', ...withEndDateArray];
  const requireTimeFields = ['time', 'timeZone'];
  const requireIntervalFields = ['count', 'type'];
  const commonFields = ['name', 'subject', 'recipients'];
  const emptyCommonFields = filter(commonFields, (field) => isEmpty(get(scheduleSendValues, field)));
  const validIntervals: IntervalTypes[] = ['day', 'week', 'month'];
  if (!isEmpty(emptyCommonFields)) {
    return false;
  }
  if (!validIntervals.includes(type as IntervalTypes)) {
    return false;
  }

  if (type === 'week') {
    requireIntervalFields.push('days');
  } else if (type === 'month') {
    requireIntervalFields.push('days');
    requireIntervalFields.push('week');
  }
  const emptyRequireIntervalFields = filterRequiredFields(
    frequencyConfig,
    requireIntervalFields,
    'intervalInfo'
  );
  const emptyRequireTimeFields = filterRequiredFields(frequencyConfig, requireTimeFields, 'timeInfo');
  const emptyRequireDateFields = filterRequiredFields(frequencyConfig, requireDateFields, 'datesInfo');
  return (
    isEmpty(emptyRequireTimeFields) && isEmpty(emptyRequireIntervalFields) && isEmpty(emptyRequireDateFields)
  );
};

const filterRequiredFields = (frequencyConfig: FrequencyConfig, section: string[], key: string) => {
  const frequencyConfigObject = get(frequencyConfig, key);
  return filter(section, (field) => isEmpty(get(frequencyConfigObject, field)?.toString()));
};
